var render, staticRenderFns
import script from "./life_insurance_review.vue?vue&type=script&lang=js"
export * from "./life_insurance_review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports